import { MainV3ApiBase } from './base';
import { PaymentIndexView } from '../types/payments';

export const PaymentApis = {
    base() {
        return MainV3ApiBase.appendPath('users/current/payments');
    },
    findAll(): Promise<PaymentIndexView[]> {
        return this.base().get();
    },
    show(code: string): Promise<PaymentIndexView> {
        return this.base()
            .withId(code)
            .get();
    },
    create(code: string): Promise<PaymentIndexView> {
        return this.base().post({
            id: code,
        });
    },
};
